import { useCallback, useRef, useState } from 'react';
import {
  DashboardMediaPopoverMode,
  IDashboardMediaPopoverProps,
  IOpenPopoverProps,
} from './types';
import { noop } from 'lodash';

const useDashboardMediaPopoverController = () => {
  const openPopoverPropsRef = useRef<IOpenPopoverProps>({
    anchorPosition: { left: 0, top: 0 },
    url: null,
    onSubmit: noop,
    mode: DashboardMediaPopoverMode.Add,
  });

  const [isOpen, setIsOpen] = useState(false);

  const onClose = useCallback(() => setIsOpen(false), []);

  const openPopover = useCallback((openPopoverProps: IOpenPopoverProps) => {
    openPopoverPropsRef.current = openPopoverProps;
    setIsOpen(true);
  }, []);

  return {
    popoverProps: {
      isOpen,
      onClose,
      ...openPopoverPropsRef.current,
    } satisfies IDashboardMediaPopoverProps,
    openPopover,
  };
};

export default useDashboardMediaPopoverController;
